<template>
  <div class="perturbedgene">
    <a-row :gutter="[12, 24]">
      <a-col
        :xs="{ span: 0 }"
        :sm="{ span: 0 }"
        :md="{ span: 0 }"
        :xl="{ span: 6 }"
        :lg="{ span: 6 }"
      >
        <a-affix :offset-top="100">
          <a-card size="small" title="Table of Contents">
            <a
              @click="changeHash('#basic')"
              type="primary"
              style="margin-top: 20px; font-size: 17px"
              >1. Basic information
            </a>
            <br />
            <!-- <a
              @click="changeHash('#score')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >2. Perturbation score of sgRNA
            </a>
            <br /> -->
            <a
              @click="changeHash('#de')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >2. Expression profile changes</a
            >
            <br />
            <a
              @click="changeHash('#pathway')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >3. GSEA Analysis
            </a>
            <br />
            <!-- <a
              @click="changeHash('#customeplot')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >5. Gene expression visualization</a
            >
            <br /> -->
            <a
              @click="changeHash('#tcga')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >4. Gene disorders of pan-cancers
            </a>
          </a-card>
        </a-affix>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 18 }"
        :gutter="[16, 24]"
      >
        <a-row>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            id="basic"
          >
            <!-- <h1 class="h1">Result of perturbed-gene</h1>
            <a-alert
              message="This page presents the results of the gene difference analysis and functional enrichment analysis of the perturbed genes."
              type="success"
              :style="{ borderRadius: '5px' }"
            /> -->
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a
                slot="title"
                class="guider"
                style="font-size: 20px; color: black"
              >
                Basic Information
              </a>
              <a-descriptions bordered size="small">
                <a-descriptions-item label="Gene">
                  {{ this.gene }}
                </a-descriptions-item>
                <a-descriptions-item label="Ensembl ID">
                  {{ this.ensgId }}
                </a-descriptions-item>
                <a-descriptions-item label="Gene type">
                  {{ this.genetype }}
                </a-descriptions-item>
                <a-descriptions-item label="Alias">
                  {{ this.alias }}
                </a-descriptions-item>
                <a-descriptions-item label="Entrez ID">
                  {{ this.geneId }}
                </a-descriptions-item>
                <a-descriptions-item label="Gene tag">
                  <!-- <a-tag color="red">{{ this.genetag }}</a-tag> -->
                  <div style="text-align: center" v-if="this.genetag != null">
                    <div
                      v-for="(index, element) in this.genetag.split(',')"
                      :key="index"
                      :value="element"
                    >
                      <a-tag v-if="index == 'RBP'" color="pink">
                        {{ index }}
                      </a-tag>
                      <a-tag v-if="index == 'TF'" color="red">
                        {{ index }}
                      </a-tag>
                      <a-tag v-if="index == 'Metabolism'" color="orange">
                        {{ index }}
                      </a-tag>
                      <a-tag v-if="index == 'Essential'" color="green">
                        {{ index }}
                      </a-tag>
                      <a-tag v-if="index == 'E3'" color="cyan">
                        {{ index }}
                      </a-tag>
                    </div>
                  </div>
                  <div style="text-align: center" v-if="this.genetag == null">
                    <a-tooltip
                      title="The functional classification of this gene is currently not available in PerturbDB. Please get in touch with us to help us improve it."
                    >
                      <a-tag> To be determined </a-tag>
                    </a-tooltip>
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="Summary">
                  {{ this.summary }}
                </a-descriptions-item>
              </a-descriptions>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="de"
          >
            <a-card
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              size="small"
            >
              <a slot="title" class="guider" style="color: black">
                Perturbation-induced Differentially Expressed Gene
              </a>
              <a-row>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 10 }"
                  ><volcano />
                </a-col>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 14 }"
                  ><deTable
                /></a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="pathway"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black">
                Gene Set Enrichment Analysis</a
              >
              <a-tabs type="card" @change="callback">
                <a-tab-pane key="1" tab="Hallmark">
                  <hallmark />
                </a-tab-pane>
                <!-- <a-tab-pane key="2" tab="KEGG">
                  <kegg />
                </a-tab-pane>
                <a-tab-pane key="3" tab="REACTOME">
                  <reactome />
                </a-tab-pane> -->
              </a-tabs>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="tcga"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a class="guider" slot="title" style="color: black">
                Cancer Associations
              </a>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1">
                  <span slot="tab">
                    <a-icon type="sliders" />
                    Gene expression profile across all tumor
                  </span>
                  <tcgaAll />
                </a-tab-pane>
                <!-- <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="sliders" />
                    Gene expression profile across paired tumor and normal
                  </span>
                  <tcgaPaired />
                </a-tab-pane> -->
                <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="fall" />
                    Survival Plots
                  </span>
                  <survival v-bind:ensgId="this.ensgId" />
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
import volcano from "./volcano.vue";
import deTable from "./de_table.vue";
import tcgaAll from "./TCGA/tcgaExpressionAll.vue";
// import tcgaPaired from "./tcgaExpressionPaired.vue";
import survival from "./TCGA/survival.vue";
//pathway
import hallmark from "./hallmark.vue";
// import kegg from "./keggUpAndDown.vue";
// import wiki from "./wikiUpAndDown.vue";
// import reactome from "./reactomeUpAndDown.vue";

// import pdf from "vue-pdf";
export default {
  components: {
    volcano,
    deTable,
    tcgaAll,
    // tcgaPaired,
    survival,
    hallmark,
    // kegg,
    // wiki,
    // reactome,
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
        {
          params: {
            genename: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        //同一转一下.
        this.gene = response.data[0]["genename"];
        this.ensgId = response.data[0]["ensgId"];
        this.genetype = response.data[0]["genetype"];
        this.alias = response.data[0]["alias"]
          .replaceAll("|", ",")
          .substring(
            1,
            response.data[0]["alias"].replaceAll("|", ",").length - 1
          );
        this.geneId = response.data[0]["geneid"];
        this.genetag = response.data[0]["genetag"];
        this.summary = response.data[0]["summary"];
      });
  },
  data() {
    return {
      svgSrc:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/batchPlot/" +
        this.$route.query.gene +
        ".score.png",
      //basic infor
      gene: "",
      ensgId: "",
      genetype: "",
      alias: "",
      geneId: "",
      genetag: "",
      summary: "",
    };
  },
  methods: {
    changeHash(idname) {
      document.querySelector(idname).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.guider {
  font-weight: bolder;
  font-size: 20px;
}
.pdf-content {
  overflow: hidden;
  height: 50px;
}
</style>
